import PhoneNumber from "awesome-phonenumber";

const newNcellNumberRegex = /^(97)\d{8}$/;

export const isNewPhoneNumber = (phoneNumber: string): boolean =>
  newNcellNumberRegex.test(phoneNumber);

export const isStartWith97 = (phNumber: string): boolean => {
  const clean = phNumber.replace(/\s/g, "");
  return clean.slice(4, 6) === "97";
};

export const isValidPhone = (value: string): boolean => {
  const ph = new PhoneNumber(value);
  const phoneNumber = ph.getNumber("significant");
  if (ph.getCountryCode() === 977 && isStartWith97(value)) {
    return isNewPhoneNumber(phoneNumber);
  }
  return ph.isValid() && ph.isMobile();
};
